/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Email_Send_LinkInputs */



/**
* | output |
* | --- |
* | "Send link" |
*
* @param {Profile_Email_Send_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_email_send_link = /** @type {((inputs?: Profile_Email_Send_LinkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Email_Send_LinkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoyer le lien")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviar enlace")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enviar link")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invia link")
	return /** @type {LocalizedString} */ ("Send link")
});